import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import axios from '../../utils/axios';

class AdminInfo extends React.Component {
    state = {
        databaseInfo: null,
        loading: false
    }

    componentWillUnmount() {
        this.request = null;
    }

    toggleVisibility = () => {
        if (this.request) return;
        if (this.state.databaseInfo) {
            this.setState({ databaseInfo: null });
            return;
        }
        const { serialNo, enqueueSnackbar } = this.props;
        if (!serialNo) {
            enqueueSnackbar('缺少设备 serialNo，无法获取管理员信息', { variant: 'error' });
            return;
        }
        const request = {};
        this.request = request;
        this.setState({ loading: true });
        axios.post('/vpn/getDatabaseInfo', null, { params: { serialNo } }).then(response => {
            if (this.request !== request) return;
            this.request = null;
            this.setState({ loading: false, databaseInfo: response.resData || null });
            if (!response.resData) {
                enqueueSnackbar('暂无管理员信息', { variant: 'error' });
            }
        }, err => {
            if (this.request !== request) return;
            this.request = null;
            this.setState({ loading: false });
            enqueueSnackbar(err || '获取管理员信息失败，请重试', { variant: 'error' });
        });
    }

    render() {
        const { classes } = this.props;
        const { databaseInfo, loading } = this.state;
        return (
            <React.Fragment>
                <h3 className={classes.modelTitle}>
                    管理员信息
                    <IconButton
                        className={classes.copyBtn}
                        aria-label={databaseInfo ? '隐藏管理员信息' : '显示管理员信息'}
                        aria-expanded={!!databaseInfo}
                        disabled={loading}
                        onClick={this.toggleVisibility}
                    >
                        {databaseInfo ? <VisibilityIcon classes={{ root: classes.copyBtnRoot }} /> :
                            <VisibilityOffIcon classes={{ root: classes.copyBtnRoot }} />}
                    </IconButton>
                </h3>
                {loading && <p className={classes.modelLine} role="status">加载中...</p>}
                {databaseInfo && [
                    ['databaseName', '数据库名称'],
                    ['databasePassword', '数据库密码'],
                    ['posAdminPassword', 'pos-admin密码']
                ].map(([field, label]) => (
                    <p key={field} className={classes.modelLine} style={{ overflowWrap: 'break-word' }}>
                        <span className={classes.detailName}>{label}:</span>
                        <span>{databaseInfo[field] == null ? '-' : databaseInfo[field]}</span>
                    </p>
                ))}
            </React.Fragment>
        );
    }
}

export default AdminInfo;
